import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Recente activiteit',
  actions: {
    clicked: 'Geklikt',
    open: 'Geopend',
    scheduled: 'Gepland',
    sent: 'Verzonden',
  },
  fields: {
    recipients: '{{recipients}} ontvangers',
    opened: '{{rate}} geopend',
    clicked: '{{rate}} geklikt',
    awaiting: 'Wacht op bevestiging',
  },
  template_types: TemplateNames,
};
